import { Link } from 'react-router-dom'
import ContentShell from '../components/blog/ContentShell'
import Seo from '../components/blog/Seo'
import Breadcrumbs from '../components/blog/Breadcrumbs'
import DemoConverter from '../components/tools/DemoConverter'
import { breadcrumbJsonLd } from '../lib/seo'

export default function DemoPage() {
  return (
    <ContentShell>
      <Seo
        title="Live Demo — PDF Bank Statement to Excel | BankStatementReader"
        description="See BankStatementReader convert a bank statement PDF into clean Excel/CSV rows. Run the live demo on a synthetic sample statement — no signup, no upload."
        canonicalPath="/demo"
        jsonLd={[breadcrumbJsonLd([{ name: 'Home', path: '/' }, { name: 'Demo', path: '/demo' }])]}
      />
      <div className="mx-auto max-w-3xl pt-6">
        <Breadcrumbs crumbs={[{ name: 'Home', path: '/' }, { name: 'Demo', path: '/demo' }]} />
        <h1 className="text-[clamp(2rem,3vw+1rem,2.8rem)] font-bold tracking-tight text-ink leading-tight m-0">
          Live demo
        </h1>
        <p className="text-ink-soft mt-4 mb-8 text-lg">
          Watch a PDF bank statement turn into clean, exportable rows. This runs on a synthetic sample
          statement so you can see the exact output — dates, descriptions, debits, credits and running
          balance — and download the Excel, CSV, or JSON before signing up.
        </p>

        <DemoConverter />

        <div className="mt-10 rounded-2xl border border-black/5 bg-surface p-6 text-center">
          <p className="text-ink font-semibold m-0">Ready to convert your own statements?</p>
          <p className="text-ink-soft mt-2 mb-5">Sign up and upload a PDF to get real transactions back in seconds.</p>
          <Link
            to="/sign-up"
            className="inline-block px-6 py-2.5 rounded-full bg-accent text-[#06301c] font-semibold hover:bg-accent-dark hover:text-white transition"
          >
            Get started free
          </Link>
        </div>
      </div>
    </ContentShell>
  )
}
